import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { LOCAL_STORAGE_KEYS } from '../utils/common/local-storage-keys';
import { safeSSRZustandStorage } from '../utils/common/safe-ssr-zustand-storage';
import { MockedTimeManager } from '../utils/MockedTimeManager';
import { createSelectors } from '../utils/zustand/createSelectors';

interface SubscriptionBubbleState {
  /** Bubble 닫힘 상태 */
  isClosed: boolean;

  /** Bubble 닫기 */
  closeBubble: () => void;

  /** Bubble 열기 (리셋) */
  openBubble: () => void;
}

/**
 * 2월 18일 자정 이후인지 확인
 */
export const isAfterFebruary18th = () => {
  const targetDate = new Date('2026-02-19T00:00:00+09:00');
  const now = MockedTimeManager.getInstance().getMockedTime();
  return now >= targetDate;
};

/**
 * 정기배송 Bubble 상태를 관리하는 Zustand store
 * - 기본값: 2월 18일 자정 이전에는 false (Bubble 표시), 이후에는 true (Bubble 숨김)
 * - persist 미들웨어를 사용하여 localStorage에 저장
 * - PC 헤더와 모바일 하단 네비게이션에서 공유
 */
const useSubscriptionBubbleStoreBase = create<SubscriptionBubbleState>()(
  persist(
    (set) => ({
      isClosed: isAfterFebruary18th(),
      closeBubble: () => set({ isClosed: true }),
      openBubble: () => set({ isClosed: false }),
    }),
    {
      name: LOCAL_STORAGE_KEYS.PC_HEADER_SUBSCRIPTION_BUBBLE,
      storage: safeSSRZustandStorage(),
    },
  ),
);

export const useSubscriptionBubbleStore = createSelectors(
  useSubscriptionBubbleStoreBase,
);
